import { TextLabel } from '@core/components/Inputs';
import { formatCPF } from '@format';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import React from 'react';

const PessoaFisica = (props) => {
  const { handleChange, readOnly } = props;

  let { pessoaFisica = {}, inscricaoMunicipal } = props;
  if (pessoaFisica === null) {
    pessoaFisica = {};
  }

  const { cpf, identidade, dataNascimento, identificadorEstrangeiro } = pessoaFisica;
  return (
    <>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel fullWidth id="pessoa.pessoaFisica.cpf" label="CPF" value={cpf} format={formatCPF} />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel
          readOnly={readOnly}
          fullWidth
          id="pessoa.pessoaFisica.identidade"
          label="Identidade"
          value={identidade}
          onChange={handleChange}
          maxLength={10}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel
          readOnly={readOnly}
          disableFuture
          id="pessoa.pessoaFisica.dataNascimento"
          label="Data de nascimento"
          value={dataNascimento}
          onChange={handleChange}
          format={(value) => {
            if (value) {
              return moment(value).format('DD/MM/YYYY');
            }
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel
          readOnly={readOnly}
          fullWidth
          id="pessoa.pessoaFisica.identificadorEstrangeiro"
          label="Identificador estrangeiro"
          onChange={handleChange}
          value={identificadorEstrangeiro}
          maxLength={15}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel id="pessoa.inscricaoMunicipal" label="Inscrição municipal" value={inscricaoMunicipal} />
      </Grid>
    </>
  );
};

export default PessoaFisica;
